export default __webpack_public_path__ + "static/media/12-29.43330696.png";